export const signupRoutesName = {
    signUp: "signup",
};
